<template>
  <ConfirmModal :title="title">
    <template #body>
      <section class="estate-account-select">
        <EstateAccountSelect
          ref="estateAccountSelect"
          v-model="selectedEstateAccountId"
          :config="configInternal"
          :query-params="queryParams"
          :show-profession="showProfession"
        />
      </section>
    </template>
    <template #footer>
      <button
        class="button"
        type="button"
        @click="close()"
        :data-e2e="EstateAccountCypressAttribute.estateSelectionModal.buttons.CANCEL"
      >
        {{ $t('accounting.cancel') }}
      </button>
      <ButtonView
        class="button is-primary"
        :disabled="isSubmitDisabled"
        :loading="isLoading"
        @click="confirm()"
        :data-e2e="EstateAccountCypressAttribute.estateSelectionModal.buttons.GO"
      >
        {{ $t('estateaccount.go') }}
      </ButtonView>
    </template>
  </ConfirmModal>
</template>

<script>
import { clone } from 'lodash';
import { ModalMixin } from '/@/modules/core/ui/mixins/ModalMixin';
import EstateAccountSelect from '/@/modules/estateaccount/components/EstateAccountSelect.vue';
import { EstateAccountSelectConfig } from '/@/modules/estateaccount/models/EstateAccountSelectConfig';
import { EstateAccountCypressAttribute } from '/@/modules/estateaccount/constants/EstateAccountCypressAttribute';
import { FormSelectConfig } from '/@/modules/core/form/models/FormSelectConfig';
import ConfirmModal from '/@/modules/core/ui/components/ConfirmModal.vue';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';
import Lang from '@/modules/core/app/services/Lang';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'EstateAccountSelectionModal',
  emits: ['on-submit'],
  mixins: [ModalMixin],
  components: { ButtonView, ConfirmModal, EstateAccountSelect },
  props: {
    title: {
      type: String,
      default() {
        return Lang.t('estateaccount.select-from-estate');
      }
    },
    estateId: {
      type: Number
    },
    roleIds: {
      type: Array,
      default() {
        return [];
      }
    },
    showProfession: {
      type: Boolean,
      default: false
    },
    config: {
      type: FormSelectConfig,
      required: false
    },
    params: {
      type: Object,
      default: () => ({})
    }
  },
  static: {
    EstateAccountCypressAttribute
  },
  data() {
    return {
      selectedEstateAccountId: null,
      isLoading: false,
      configInternal: {}
    };
  },
  computed: {
    isSubmitDisabled() {
      return !this.selectedEstateAccountId;
    },
    queryParams() {
      const queryParams = clone(this.params);

      if (this.estateId) {
        queryParams.estate_id = this.estateId;
      }

      if (this.roleIds.length) {
        queryParams.roleId = this.roleIds.join(',');
      }
      return queryParams;
    }
  },
  methods: {
    confirm() {
      if (this.selectedEstateAccountId) {
        this.isLoading = true;
        this.$emit('on-submit', this.$refs.estateAccountSelect.getSelectedOptions());
      }
    }
  },
  async created() {
    this.configInternal =
      this.config ??
      new EstateAccountSelectConfig({
        preselectFirst: true,
        allowEmpty: false
      });
  }
};
</script>

<style scoped>
section.estate-account-select {
  min-height: var(--ce-300px);
  overflow: hidden;
}
</style>
